module.exports = new __parcel__URL__("dark-comments-empty.21b1aead.svg").toString();